import { createSlice } from '@reduxjs/toolkit'

export const slice = createSlice({
  name: 'paginator',
  initialState: {
    byName: {}
  },
  reducers: {
    setPage: (state, action) => {
      const { name, page } = action.payload;

      if (!state.byName[name]) {
        state.byName[name] = {};
      }

      state.byName[name].page = page;
    },
    setPerPage: (state, action) => {
      const { name, perPage } = action.payload;

      if (!state.byName[name]) {
        state.byName[name] = {};
      }

      state.byName[name].page = 1;
      state.byName[name].perPage = perPage;
    },
  }
});

export const {
  setPage,
  setPerPage,
} = slice.actions;

export const selectPage = key => state => state.paginator.byName[key]?.page;
export const selectPerPage = (key, defaultValue) => state => state.paginator.byName[key]?.perPage ?? defaultValue;

export default slice.reducer;
